import React from "react";
import { motion } from "framer-motion";

// Static motion configs — module-level for stable referential identity.
const DIFF_INITIAL = { opacity: 0, y: 18 };
const DIFF_WHILE_IN_VIEW = { opacity: 1, y: 0 };
const DIFF_VIEWPORT = { once: true, amount: 0.2 };
const diffTransition = (i) => ({ duration: 0.5, delay: i * 0.05 });

const DIFFS = [
  { icon: "fa-gem", title: "Produção Personalizada", desc: "Cada projeto desenvolvido sob medida para o que sua marca precisa transmitir." },
  { icon: "fa-truck-fast", title: "Entrega Nacional", desc: "Logística estruturada para entregar em todo o Brasil com agilidade e segurança." },
  { icon: "fa-award", title: "Alta Qualidade", desc: "Materiais bem escolhidos, acabamento caprichado e produto que dura." },
  { icon: "fa-headset", title: "Atendimento Especializado", desc: "Atendimento direto, próximo e com gente que entende de brindes corporativos." },
  { icon: "fa-handshake", title: "Pedido Mínimo Acessível", desc: "A partir de 50 unidades — para pequenas, médias e grandes empresas." },
  { icon: "fa-bolt", title: "Produção Rápida", desc: "Processo otimizado para prazos curtos sem perder qualidade." },
  { icon: "fa-leaf", title: "Sustentabilidade", desc: "Produtos reutilizáveis e materiais sustentáveis para empresas conscientes." },
  { icon: "fa-tags", title: "Excelente Custo-Benefício", desc: "Qualidade de verdade com preço justo e transparente." },
];

export const Differentials = () => {
  return (
    <section id="diferenciais" data-testid="differentials-section" className="mn-section" style={{ background: "var(--mn-cream)" }}>
      <div className="mn-container">
        <div className="max-w-3xl mb-14">
          <span className="mn-eyebrow">Por que M NAIEF</span>
          <h2 className="mn-h-display text-[2.25rem] sm:text-[2.75rem] lg:text-[3.25rem] mt-4">
            Motivos para a sua empresa <span style={{ color: "var(--mn-gold)" }}>escolher a gente.</span>
          </h2>
          <p className="mt-5 text-[var(--mn-dark)] text-base sm:text-lg leading-relaxed">
            Mais do que brindes — entregamos atendimento, processo e qualidade em cada etapa.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-testid="differentials-grid">
          {DIFFS.map((d, i) => (
            <motion.div
              key={d.title}
              initial={DIFF_INITIAL}
              whileInView={DIFF_WHILE_IN_VIEW}
              viewport={DIFF_VIEWPORT}
              transition={diffTransition(i)}
              className="mn-diff"
              data-testid={`diff-card-${i}`}
            >
              <div className="mn-diff-ico">
                <i className={`fa-solid ${d.icon}`} />
              </div>
              <h3 className="font-serif-display font-bold text-lg text-[var(--mn-black)] leading-snug">
                {d.title}
              </h3>
              <p className="mt-3 text-sm text-[var(--mn-dark)] leading-relaxed">{d.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentials;
